import styled from '@emotion/styled';
import { Box, TableCell } from '@mui/material';
import { TableCellStyled } from '../table-sort/table-sort.styles';

interface CardFirstSectionContainerProps {
  isMobile?: boolean;
}

export const CardFirstSectionContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <CardFirstSectionContainerProps>`
  padding: ${({ isMobile }) => (isMobile ? "16px 8px 16px" : "16px")};
`

export const TableCellName = styled(TableCellStyled, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <TableCellIconStyledProps>`
  max-width: ${({ isMobile }) => (isMobile ? "48px" : "74px")};
`

interface TableCellIconStyledProps {
  isMobile?: boolean;
}

export const TableCellIconStyled = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <TableCellIconStyledProps>`
  padding: ${({ isMobile }) => (isMobile ? "4px" : "8px")};
`